import type { VideoPlatform } from '@/lib/video-metadata';

export type LibrarySourceId = 'youtube' | 'instagram' | 'twitch' | 'google-drive' | 'dropbox' | 'frameio' | 'mediasilo';
export type LibrarySourcePlatform = VideoPlatform | 'file';
export type LibrarySourceAccess = 'allowed' | 'pro_required' | 'unsupported';

export const LIBRARY_URL_SOURCES = [
  { id: 'youtube', labelKey: 'library.sources.youtube', pro: false },
  { id: 'instagram', labelKey: 'library.sources.instagram', pro: true },
  { id: 'twitch', labelKey: 'library.sources.twitch', pro: true },
  { id: 'dropbox', labelKey: 'library.sources.dropbox', pro: true },
  { id: 'frameio', labelKey: 'library.sources.frameio', pro: true },
  { id: 'mediasilo', labelKey: 'library.sources.mediasilo', pro: true },
  { id: 'google-drive', labelKey: 'library.sources.googleDrive', pro: true },
] as const satisfies ReadonlyArray<{ id: LibrarySourceId; labelKey: string; pro: boolean }>;

export function resolveLibrarySourceAccess({
  platform,
  hasProAccess,
}: {
  platform: LibrarySourcePlatform;
  hasProAccess: boolean;
}): LibrarySourceAccess {
  if (platform === 'unknown') return 'unsupported';
  if (platform === 'youtube') return 'allowed';
  return hasProAccess ? 'allowed' : 'pro_required';
}
